import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Sender } from "@circle-react/types/Chat/ChatRoomMessage";
import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";
import type { Editor } from "@tiptap/react";

import { t } from "@/i18n-js/instance";

interface MessageItemCompassButtonProps {
  attachmentsCount: number;
  editor: Editor;
  messageBody: string;
  onKeyDownHandler: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  redirectToLink: () => void;
  sender: Sender;
  timeAgo: string;
}

export const MessageItemCompassButton = ({
  redirectToLink,
  onKeyDownHandler,
  editor,
  sender,
  messageBody,
  attachmentsCount,
  timeAgo,
}: MessageItemCompassButtonProps) => (
  <button
    type="button"
    onClick={redirectToLink}
    onKeyDown={onKeyDownHandler}
    className={classNames(
      "bg-primary border-primary hover:border-hover hover:bg-hover relative flex shrink-0 cursor-pointer flex-row space-x-3 rounded-lg border px-4 py-3 text-left max-w-full sm:w-[304px]",
      editor.isEditable ? "w-[274px] md:w-[328px]" : "w-[286px] md:w-[363px]",
    )}
  >
    <div className="shrink-0">
      <Avatar src={sender.avatar_url} name={sender.name} />
    </div>
    <div className="min-w-0 flex-1">
      <div className="mb-0.5 flex flex-row items-center space-x-2 truncate">
        <Typography variant="label-sm" className="truncate">
          {sender.name}
        </Typography>
        <Typography variant="caption" color="tertiary">
          {timeAgo}
        </Typography>
      </div>

      {messageBody && (
        <Typography
          variant="body-sm"
          color="secondary"
          className="line-clamp-2"
        >
          {messageBody}
        </Typography>
      )}
      {attachmentsCount > 0 && (
        <Typography variant="body-sm" color="secondary" className="pt-0.5">
          {t("bookmarks.attachments_count", { count: attachmentsCount })}
        </Typography>
      )}
    </div>
  </button>
);
